import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "@material-ui/core/Card";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";

import CustomizedSnackbar from "../Snackbar/CustomizedSnackbar.jsx";
import SureDialog from "../Dialogs/SureDialog.jsx";

import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import green from "@material-ui/core/colors/green";

import moment from "moment";
import firebase from "firebase/app";
import "firebase/database";

import scanBeep from "../Media/scanBeep.wav";

const styles = theme => ({
  numButton: {
    width: "98%",
    height: "90%",
    fontSize: "1.4rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: 10
    }
  },
  lateStart: {
    width: "98%",
    height: "98%",
    fontSize: "1.4rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: 10
    }
  },
  enterButton: {
    width: "98%",
    height: "100%",
    fontSize: "2rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
      height: "98%"
    }
  },
  bibNumber: {
    paddingTop: 5,
    fontSize: "2.2rem",
    textAlign: "center",
    height: 50,
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
      height: 20
    }
  },
  card: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: 300,
    left: 0,
    margin: 0,
    [theme.breakpoints.down("xs")]: {
      height: 210
    }
  },

  resultsCard: {
    height: "calc(100vh - 380px)",
    overflow: "auto",
    position: "absolute",
    top: 60,
    left: 0,
    width: "calc(100% - 30px)",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 297px)"
    }
  },
  numSpacer: {
    height: 50,
    [theme.breakpoints.down("xs")]: {
      height: 20
    }
  },
  stopButton: {
    position: "absolute",
    right: 10,
    top: 10,
    zIndex: 100
  },
  deleteIcon: {
    color: theme.palette.error.dark
  },
  checkmarkIcon: {
    color: green[600]
  },
  playButton: {
    background: green[600]
  }
});

class numericTapper extends React.Component {
  constructor() {
    super();
    this.state = {
      value: "",
      lastValue: "",
      results: [],
      lateStart: new Array(2000).fill(null),
      users: [],
      deletedRows: [],
      snackbarTrigger: false,
      snackbarVariant: "success",
      timerStart: "",
      today: moment().format("YYYY-MM-DD"),
      scanBeep: new Audio(scanBeep)
    };
  }

  componentDidMount = () => {
    firebase
      .database()
      .ref("raceResults/" + this.state.today)
      .once("value", snapshot => {
        const race = snapshot.val();
        if (race && race.running) {
          this.setState({
            timerStart: race.timerStart,
            results: race.numeric
              ? Object.keys(race.numeric).map(key => race.numeric[key])
              : []
          });
        }
        if (race && !race.running) {
          firebase
            .database()
            .ref("backup/" + this.state.today)
            .push(race);
        }
      });
    var users = new Array(2000).fill(null);
    firebase
      .database()
      .ref("users")
      .once("value", snapshot => {
        snapshot.val().forEach(user => {
          users[user.bibNumber] = `${user.firstName} ${user.surname}`;
        });
        this.setState({ users });
      });
  };

  componentWillUnmount = () => {
    firebase
      .database()
      .ref("raceResults/" + this.state.today + "/numeric_backup")
      .push(this.state.results);
  };

  onNumAdded = num => {
    this.setState(prevState => {
      if (num === "clear") {
        return (prevState.value = "");
      }
      if (num === "no bib") {
        return (prevState.value = 99999);
      }
      if (prevState.value === "no bib") {
        return (prevState.value = num + "");
      }
      return (prevState.value += num);
    });
  };

  onSubmitNum = () => {
    if (this.state.value === "") {
      this.triggerSnackbar("Enter bib number first", "error");
      return;
    }

    const finisher = {
      clockTime: moment().valueOf(),
      finishTime: this.state.timerStart ? this.getFinishTime() : "-",
      bibNumber: Number(this.state.value)
    };

    const lateStartTime = this.state.lateStart[this.state.value];
    if (lateStartTime !== null) {
      console.log(lateStartTime);
      finisher.lateStartTime = moment(lateStartTime).format("hh:mm:ss");
      finisher.finishTime = this.getFinishTime(lateStartTime);
    }

    this.setState(
      prevState => {
        prevState.results.unshift(finisher);
        prevState.value = "";
        return prevState;
      },
      () => this.state.scanBeep.play()
    );
    firebase
      .database()
      .ref("raceResults/" + this.state.today + "/numeric/" + finisher.clockTime)
      .set(finisher);
  };

  getFinishTime = lateStart => {
    var now = moment().valueOf();
    var start = lateStart ? lateStart : this.state.timerStart;
    var diff = now - start;
    var seconds = diff / 1000;
    var hours = parseInt(seconds / 3600);
    seconds = seconds % 3600;
    var minutes = parseInt(seconds / 60);
    seconds = Math.round(seconds % 60);

    return `${hours > 0 ? "0" + hours + ":" : ""}${
      minutes < 10 ? "0" + minutes : minutes
    }:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  numButton = label => {
    const { classes } = this.props;
    return (
      <Grid item xs={4} key={label}>
        <Button
          variant="contained"
          className={classes.numButton}
          onClick={() => this.onNumAdded(label)}
        >
          {label}
        </Button>
      </Grid>
    );
  };

  onSnackbarClose = () => {
    this.setState({ snackbarTrigger: false });
  };

  onTimerStart = () => {
    const ref = firebase.database().ref("raceResults/" + this.state.today);
    ref.child("running").once("value", snapshot => {
      if (!snapshot.val()) {
        ref.set({ running: true, timerStart: moment().valueOf() });
      }
      this.setState({ timerStart: moment().valueOf() });
    });
  };

  lateStart = () => {
    if (this.state.value === "") {
      this.triggerSnackbar("Enter bib number first", "error");
      return;
    }
    this.setState(
      prevState => {
        prevState.lateStart[this.state.value] = moment().valueOf();
        prevState.lastValue = prevState.value;
        prevState.value = "";
        return prevState;
      },
      () => {
        this.state.scanBeep.play();
        this.triggerSnackbar(
          `Added ${this.state.lastValue} as late start`,
          "success",
          this.undoLateStart
        );
      }
    );
  };

  undoLateStart = () => {
    this.setState(prevState => {
      prevState.lateStart[this.state.lastValue] = null;
      return prevState;
    }, this.triggerSnackbar(`Removed ${this.state.lastValue} from late start`, "warning"));
  };

  stopButtonClicked = () => {
    this.sure("End Race?", "are you sure you want to invalidate the timer");
  };

  sure = (title, msg) => {
    this.setState({ sureTitle: title, sureMessage: msg, sureTriggered: true });
  };

  onCloseDialog = () => {
    this.setState({ sureTriggered: false });
  };

  onSureAgree = () => {
    this.setState({ timerStart: "" });
    clearInterval(this.state.intervalId);
    this.setState({
      playDisabled: false,
      today: moment().format("YYYY-MM-DD"),
      sureTriggered: false
    });

    firebase
      .database()
      .ref("raceResults/" + this.state.today + "/running")
      .set(false);
  };

  onDeleteRow = index => {
    this.setState(prevState => {
      prevState.deletedRows.push(index);
      return prevState;
    }, this.writeResults);
  };

  onReturnRow = index => {
    this.setState(prevState => {
      const toRemove = prevState.deletedRows.indexOf(index);
      if (toRemove !== -1) {
        prevState.deletedRows.splice(toRemove, 1);
      }
      return prevState;
    });
  };

  triggerSnackbar = (message, variant, undo) => {
    this.setState({
      snackbarMessage: message,
      snackbarVariant: variant,
      snackbarTrigger: true,
      snackbarUndo: undo
    });
  };

  renderActionCell = index => {
    const { classes } = this.props;

    return (
      <TableCell>
        {this.state.deletedRows.indexOf(this.state.results.length - index) ===
        -1 ? (
          <IconButton
            className={classes.checkmarkIcon}
            aria-label="Delete"
            color="primary"
            disabled={
              this.state.deletedRows.indexOf(
                this.state.results.length - index
              ) !== -1
            }
            onClick={() => this.onDeleteRow(this.state.results.length - index)}
          >
            <CheckIcon />
          </IconButton>
        ) : (
          <IconButton
            className={classes.deleteIcon}
            aria-label="check"
            color="primary"
            onClick={() => this.onReturnRow(this.state.results.length - index)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </TableCell>
    );
  };

  render() {
    const { classes } = this.props;
    const buttons = [1, 2, 3, 4, 5, 6, 7, 8, 9, "no bib", 0, "clear"];
    return (
      <React.Fragment>
        <SureDialog
          title={this.state.sureTitle}
          message={this.state.sureMessage}
          triggered={this.state.sureTriggered}
          onAgree={this.onSureAgree}
          onDisagree={this.onCloseDialog}
        />
        <CustomizedSnackbar
          message={this.state.snackbarMessage}
          trigger={this.state.snackbarTrigger}
          variant={this.state.snackbarVariant}
          onClose={this.onSnackbarClose}
          onUndo={this.state.snackbarUndo}
        />

        <Card className={classes.resultsCard}>
          <Button
            variant="fab"
            color="secondary"
            aria-label="Edit"
            className={classes.stopButton}
            disabled={this.state.timerStart === ""}
            onClick={this.stopButtonClicked}
          >
            <StopIcon />
          </Button>

          {this.state.timerStart === "" ? (
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.onTimerStart}
            >
              Start Timer
            </Button>
          ) : (
            `Timer Started: ${moment(this.state.timerStart).format("HH:mm:ss")}`
          )}
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Position</TableCell>
                <TableCell>Clock Time</TableCell>
                <TableCell>Finish Time</TableCell>
                <TableCell>Bib Number</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.results.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{this.state.results.length - index} </TableCell>
                    <TableCell>
                      {moment(row.clockTime).format("hh:mm:ss")}
                    </TableCell>
                    <TableCell>{row.finishTime} </TableCell>
                    <TableCell>{row.bibNumber} </TableCell>
                    <TableCell>{this.state.users[row.bibNumber]}</TableCell>
                    {this.renderActionCell(index)}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Card>

        <Card className={classes.card}>
          <Grid container className={classes.numContainer}>
            <Grid item xs={12}>
              {!this.state.value ? (
                <div className={classes.numSpacer} />
              ) : (
                <div className={classes.bibNumber}>{this.state.value}</div>
              )}
            </Grid>
            <Grid item xs={1}>
              <Button
                variant="contained"
                className={classes.lateStart}
                onClick={this.lateStart}
              >
                Late Start
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Grid container>{buttons.map(l => this.numButton(l))}</Grid>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                className={classes.enterButton}
                onClick={this.onSubmitNum}
              >
                Enter
              </Button>
            </Grid>
          </Grid>
          <div className={classes.bibNumber} />
        </Card>
      </React.Fragment>
    );
  }
}

numericTapper.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(numericTapper);
